export default {
  computed: {
    contactReference () {
      return {
        title: this.contactModel.id ? this.$t('message.customer.updateContact') : this.$t('message.customer.addContact'),
        properties: [{
          model: 'firstname',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.user.firstName'),
          class: 'lg4 md4 sm6'
        }, {
          model: 'lastname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.user.lastName'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.email'),
          class: 'lg5 md4 sm6'
        }, {
          model: 'mobilephone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.mobile')}`,
          class: 'lg3 md4 sm6'
        }, {
          model: 'telephone',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.telephone')}`,
          class: 'lg3 md4 sm6'
        }, {
          model: 'note',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.common.note'),
          class: 'lg4 md4 sm6'
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 sm6 my-auto',
          label: this.$t('message.common.isActive')
        }, {
          model: 'receive_certificate',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg4 sm6 my-auto',
          label: this.$t('message.customer.receiveCertificate')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.contactModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateContactHandler(),
          loading: this.contactLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewContact(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    addressReference () {
      return {
        title: this.addressModel.id ? this.$t('message.customer.updateAddress') : this.$t('message.customer.addAddress'),
        properties: [{
          model: 'address',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.address'),
          class: 'lg6 md6 sm12'
        }, {
          model: 'address2',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.customer.address')} 2`,
          class: 'lg6 md6 sm12'
        }, {
          model: 'postbox',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.postbox'),
          class: 'lg4 md4 sm6'
        }, {
          model: 'postcode',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          change: () => this.loadAllCityByPost(),
          label: this.$t('message.customer.postCode'),
          class: 'lg2 md4 sm6'
        }, {
          model: 'city',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          loading: this.isLoading,
          label: this.$t('message.customer.city'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'countryname',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.country'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'latitude',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_numberValidation,
          label: this.$t('message.customer.latitude'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'longitude',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_numberValidation,
          label: this.$t('message.customer.longitude'),
          class: 'lg3 md4 sm6'
        }, {
          model: 'type',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.product.type'),
          items: this.$_listOfAddressTypes,
          select_text: 'title',
          select_value: 'value',
          class: 'lg4 md4 sm6'
        }, {
          model: 'notes',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.common.note'),
          class: 'lg9 md9 sm12'
        }, {
          model: 'isstandard',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg3 md3 sm6 my-auto',
          label: this.$t('message.customer.isStandard')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.addressModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateAddressHandler(),
          loading: this.addressLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          click: () => this.closeAddNewAddress(),
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    paymentTerms () {
      return [
        { text: `0 ${this.$t('message.common.days')}`, value: 0 },
        { text: `5 ${this.$t('message.common.days')}`, value: 5 },
        { text: `10 ${this.$t('message.common.days')}`, value: 10 },
        { text: `15 ${this.$t('message.common.days')}`, value: 15 },
        { text: `30 ${this.$t('message.common.days')}`, value: 30 },
        { text: `45 ${this.$t('message.common.days')}`, value: 45 }
      ]
    }
  }
}
